import { useRouterExtended } from "@/global/hooks/useRouterExtended";
import { useAppStore } from "@/global/store";
import { findActiveEventFromRouter } from "../utils.events";
import { selectEvents } from "@/global/store/data/purchaseSeats/events";
import { selectCartEventActive } from "@/global/store/data/purchaseSeats/cartManager";

export function useSelectActiveEvent() {
  const router = useRouterExtended();
  const events = useAppStore(selectEvents);
  const activeEvent = findActiveEventFromRouter(router, events);
  const urlActiveEventCode = router?.query?.eventCode as string;
  const cartEventActive = useAppStore(selectCartEventActive(activeEvent));

  return { activeEvent, cartEventActive, urlActiveEventCode };
}
